import { useTranslation } from '@/contexts/i18n-context';
import styles from './styles.module.css';
import clsx from 'clsx';
import { TranslationKey } from '@/contexts/translations';

interface LoaderProps {
  className?: string;
  type: 'large' | 'small' | 'button';
  textKey?: TranslationKey;
}

export function Loader({ type, className, textKey = 'common.loading' }: LoaderProps) {
  const { t } = useTranslation();
  return (
    <div className={clsx(styles[`${type}Container`], className)}>
      <div className={clsx(styles.loader, styles[type])}></div>
      {type === 'small' && <span className="body-3">{t(textKey)}</span>}
      {type === 'button' && t(textKey)}
    </div>
  );
}
